/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Counter types for dynamic export runs
 */
export enum EnumDynamicExportRunCounterTypes {
    /**
     * Counter for invoices-accounting exports
     */
    InvoicesAccounting = 0,
    /**
     * Counter for exports
     */
    Generic = 1,
    /**
     * Counter for invoice snapshot exports
     */
    InvoiceSnapshots = 2,
}
